export default {
    state: {
        enabled: false
    },

    mutations: {
        setFilter(state, payload) {
            state.enabled = payload;
        }
    }
}